import { FC } from 'react'
import cx from 'classnames'

import { colors } from '../../theme'
import { Icons } from '../Icon'
import { LinkProps } from '../Link'

import * as SC from './styled'
import { ActionIconBackground, ActionIconPosition } from './types'

export type ActionButtonProps = LinkProps & {
  className?: string
  iconColor?: string | keyof typeof colors
  iconPosition?: ActionIconPosition
  iconBackground?: ActionIconBackground
}

const ActionButton: FC<ActionButtonProps> = ({
  className,
  iconColor,
  iconPosition,
  iconBackground = ActionIconBackground.default,
  ...linkProps
}) => {
  return (
    <SC.Container
      className={cx('ActionButton', className)}
      $iconPosition={iconPosition}
      {...linkProps}
    >
      <SC.Label>{linkProps?.text ?? linkProps?.label}</SC.Label>
      <SC.Decoration
        aria-hidden
        $position={iconPosition}
        $color={iconColor}
        $background={iconBackground}
      >
        <SC.Arrow icon={Icons.arrowRight} width={24} height={24} />
      </SC.Decoration>
    </SC.Container>
  )
}

export default ActionButton
